import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@snowplow/browser-tracker';

export const useSnowplow = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        trackPageView();
    }, [pathname]);
};
